

















































import { Component, Prop } from "vue-property-decorator";
import _ from "lodash";

import AppVue from "@/AppVue.vue";
import { ParticipantModel } from "@/core/models";
import { CompanyService, UserService } from "@/core/services";
import { BaseFormComponent } from "@/core/components";

@Component
export default class WorkshopParticipantsAttendanceGridCpt extends AppVue {
  @Prop() workshopId: number;

  updating = false;
  loading = false;
  model = [] as ParticipantModel[];
  search = "";

  get participants() {
    return !this.model
      ? []
      : this.model.filter(data => !this.search || data.companyName.toLowerCase().includes(this.search.toLowerCase()));
  }

  async created() {
    this.initializeModel();
  }

  private async updateAttendance(participant: ParticipantModel) {
    this.updating = true;
    try {
      await UserService.updateAttendance(participant.userId, this.workshopId, participant.hasAttended);
      this.$emit("participant-updated", participant);
      this.initializeModel();
    } finally {
      this.updating = false;
    }
  }
  private async initializeModel() {
    this.loading = true;
    try {
      this.model = await CompanyService.getParticipants(this.workshopId);
    } finally {
      this.loading = false;
    }
  }
}
